import { Action } from "../../../actions/actions";
import { ConfigurationsActionTypes } from "../actions/actionTypes";
import _ from "lodash";

export function mailingLists(state: any[] = [], action: Action) {
    switch (action.type) {
        case ConfigurationsActionTypes.GET_MAILING_LISTS_SUCCESS:
            return action.payload.results && action.payload.results.length > 0
                ? _.cloneDeep(action.payload.results)
                : [];
        default:
            return state;
    }
}

export function mailingListsLoading(state: boolean = false, action: Action) {
    switch (action.type) {
        case ConfigurationsActionTypes.GET_MAILING_LISTS:
            return true;

        case ConfigurationsActionTypes.GET_MAILING_LISTS_FAIL:
        case ConfigurationsActionTypes.GET_MAILING_LISTS_SUCCESS:
            return false;

        default:
            return state;
    }
}
